import { PrecoModel } from './../../model/produto/preco.model';
import { Observable } from 'rxjs/Observable';
import { ResponsePageable } from './../../model/cliente/pageable/responsePageable.model';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { environment } from './../../../environments/environment.prod';
import { Injectable } from '@angular/core';

@Injectable()
export class PrecoService {

  apiURL = environment.API;

  httpOptions = {
    headers : new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('ticket', sessionStorage.getItem('ticket-ECM'))
  .set('Authorization', sessionStorage.getItem('tokenAuth'))
  };

  constructor(private httpClient: HttpClient) { }

  getPagePreco(page, size): Observable<ResponsePageable> {
    return this.httpClient.get<ResponsePageable>(this.apiURL + `/view/listar-precos?page=${page}&size=${size}`, this.httpOptions);
  }

  getPreco(): Observable<ResponsePageable>{
    return this.httpClient.get<ResponsePageable>(this.apiURL + '/view/listar-precos', this.httpOptions);
  }

  postPreco(grupoProduto: PrecoModel): Observable<PrecoModel>{
    return this.httpClient.post<PrecoModel>(this.apiURL + '/new/adicionar-preco', grupoProduto, this.httpOptions);
  }

  putPreco(grupoProduto: PrecoModel): Observable<PrecoModel>{
    return this.httpClient.put<PrecoModel>(this.apiURL + '/edit/editar-preco', grupoProduto, this.httpOptions);
  }

  deletePreco(id: any){
    const headers = new HttpHeaders()
      .set('ticket', sessionStorage.getItem('ticket-ECM'))
      .set('Authorization', sessionStorage.getItem('tokenAuth'));

    return this.httpClient.get(this.apiURL + '/delete/apagar-preco/' + id, { responseType: 'text', headers });
  }

  getPrecoUnico(id: any): Observable<PrecoModel> {
    return this.httpClient.get<PrecoModel>(this.apiURL + '/view/listar-preco/' + id, this.httpOptions);
  }

  getPrecosPorCodProduto(page, size, id: any): Observable<ResponsePageable>{
    return this.httpClient.get<ResponsePageable>
    (this.apiURL + '/view/listar-precos-produto/' + id + `/?page=${page}&size=${size}` , this.httpOptions);
  }

  getPrecoPadraoPorProduto(id: any): Observable<PrecoModel> {
    return this.httpClient.get<PrecoModel>(this.apiURL + '/view/listar-preco-padrao/' + id, this.httpOptions);
  }

}



// WEBPACK FOOTER //
// /app/src/app/service/produto/preco.service.ts